var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { CANADA_PROVINCES, CustomerEntityTypeOptions, USA_STATES, } from '../../config/constants';
import { formatSINInput, formatSSNInput, formatTaxIdInput, } from '../../utils/customerPortalValidations';
import { BILLING_ADDRESS_PREFIX, CUSTOMER_ASPIRE_FIELD, CUSTOMER_FIELD, MAIN_ADDRESS_PREFIX, } from './config/create_application_schema';
import { buildAddressFieldName, CANADA_COUNTRY_CODE, formatAmountInput, formatPhoneInput, getTitleOptions, } from './config/form_field_factories';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
var ENTITY_TYPE = { Customer: 'CUSTOMER' };
var ACCOUNT_TYPE_BUSINESS = 'B';
var ACCOUNT_TYPE_INDIVIDUAL = 'I';
var SOLE_PROPRIETORSHIP = 'Sole Proprietorship';
var resolveAccountType = function (isConsumerProgram) {
    return isConsumerProgram ? ACCOUNT_TYPE_INDIVIDUAL : ACCOUNT_TYPE_BUSINESS;
};
var toRawTaxId = function (value) {
    return String(value !== null && value !== void 0 ? value : '').replace(/[^0-9A-Za-z]/g, '');
};
var findEntityTypeByCode = function (entityTypeCode) {
    return CustomerEntityTypeOptions.find(function (option) { return option.Code === String(entityTypeCode !== null && entityTypeCode !== void 0 ? entityTypeCode : ''); });
};
var fetchCustomerByTaxId = function (taxId, values, isConsumerProgram) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var rawTaxId, entityType, payLoad, response, matched, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    rawTaxId = toRawTaxId(taxId);
                    if (!rawTaxId) {
                        return [2, null];
                    }
                    entityType = findEntityTypeByCode(values[CUSTOMER_FIELD.EntityType]);
                    payLoad = __assign({ SSN: rawTaxId, AccType: resolveAccountType(isConsumerProgram), EntityType: ENTITY_TYPE.Customer }, ((entityType === null || entityType === void 0 ? void 0 : entityType.Description) === SOLE_PROPRIETORSHIP && {
                        CompanyDesc: SOLE_PROPRIETORSHIP,
                    }));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_DETAILS_BY_FED_TAX_ID,
                            payLoad: payLoad,
                            showLoader: true,
                        })];
                case 2:
                    response = _c.sent();
                    if (Number((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                        return [2, null];
                    }
                    matched = (_b = response.data.data) !== null && _b !== void 0 ? _b : {};
                    return [2, matched.CustomerInfo ? matched : null];
                case 3:
                    error_1 = _c.sent();
                    return [2, null];
                case 4: return [2];
            }
        });
    });
};
var searchAccountsByLegalName = function (name, isConsumerProgram) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var searchName, response, rows, optionsByValue_1, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    searchName = String(name !== null && name !== void 0 ? name : '').trim();
                    if (!searchName) {
                        return [2, []];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.ACCOUNT_SEARCH,
                            payLoad: {
                                Name: searchName,
                                AccType: resolveAccountType(isConsumerProgram),
                            },
                            showLoader: false,
                        })];
                case 2:
                    response = _b.sent();
                    if (Number((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                        return [2, []];
                    }
                    rows = Array.isArray(response.data.data)
                        ? response.data.data
                        : [];
                    optionsByValue_1 = new Map();
                    rows.forEach(function (row) {
                        var value = asText(row.CustomerAspireOId);
                        var label = asText(row.LegalRegisteredName) || asText(row.Name);
                        if (!value || !label || optionsByValue_1.has(value)) {
                            return;
                        }
                        optionsByValue_1.set(value, {
                            label: label,
                            value: value,
                            description: [
                                row.MainAddress,
                                row.City,
                                row.State,
                                row.PostalCode,
                                row.Country,
                            ]
                                .map(function (part) { return asText(part); })
                                .filter(Boolean)
                                .join(', '),
                        });
                    });
                    return [2, Array.from(optionsByValue_1.values())];
                case 3:
                    error_2 = _b.sent();
                    return [2, []];
                case 4: return [2];
            }
        });
    });
};
var fetchCustomerByAccountAspireOId = function (accountAspireOId, isConsumerProgram) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, matched, error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!accountAspireOId) {
                        return [2, null];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_DETAILS_BY_FED_TAX_ID,
                            payLoad: {
                                AccountAspireOId: accountAspireOId,
                                AccType: resolveAccountType(isConsumerProgram),
                                EntityType: ENTITY_TYPE.Customer,
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _c.sent();
                    if (Number((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                        return [2, null];
                    }
                    matched = (_b = response.data.data) !== null && _b !== void 0 ? _b : {};
                    return [2, matched.CustomerInfo ? matched : null];
                case 3:
                    error_3 = _c.sent();
                    return [2, null];
                case 4: return [2];
            }
        });
    });
};
var US_COUNTRY_CODE = 'USA';
var normalise = function (value) {
    return String(value !== null && value !== void 0 ? value : '').trim().toLowerCase();
};
export var resolveCountryAndState = function (rawState) {
    var state = normalise(rawState);
    if (!state) {
        return { countryCode: '', stateCode: '' };
    }
    var matches = function (option) {
        return normalise(option.code) === state || normalise(option.state) === state;
    };
    var usState = USA_STATES.find(matches);
    if (usState) {
        return { countryCode: US_COUNTRY_CODE, stateCode: usState.code };
    }
    var canadaProvince = CANADA_PROVINCES.find(matches);
    if (canadaProvince) {
        return { countryCode: CANADA_COUNTRY_CODE, stateCode: canadaProvince.code };
    }
    return { countryCode: '', stateCode: '' };
};
export var resolveEntityTypeCode = function (companyDescription) {
    var _a, _b;
    return (_b = (_a = CustomerEntityTypeOptions.find(function (option) { return normalise(option.Description) === normalise(companyDescription); })) === null || _a === void 0 ? void 0 : _a.Code) !== null && _b !== void 0 ? _b : '';
};
var resolveTitleValue = function (rawTitle, entityTypeCode) {
    var _a, _b;
    return (_b = (_a = getTitleOptions(entityTypeCode !== null && entityTypeCode !== void 0 ? entityTypeCode : '').find(function (option) { return normalise(option.label) === normalise(rawTitle); })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
};
export var formatTaxIdForDisplay = function (rawTaxId) {
    return formatTaxIdInput(toRawTaxId(rawTaxId));
};
export var toFormDate = function (value) {
    var text = asText(value);
    if (!text) {
        return '';
    }
    var parsed = new Date(text);
    if (Number.isNaN(parsed.getTime())) {
        return text;
    }
    var month = String(parsed.getMonth() + 1).padStart(2, '0');
    var day = String(parsed.getDate()).padStart(2, '0');
    return "".concat(month, "/").concat(day, "/").concat(parsed.getFullYear());
};
var buildAddressValues = function (prefix, address) {
    var _a;
    var _b = resolveCountryAndState(address.state), countryCode = _b.countryCode, stateCode = _b.stateCode;
    var fieldName = function (suffix) { return buildAddressFieldName(prefix, suffix); };
    return _a = {},
        _a[fieldName('Address')] = asText(address.street),
        _a[fieldName('Country')] = countryCode,
        _a[fieldName('City')] = asText(address.city),
        _a[fieldName('State')] = stateCode,
        _a[fieldName('PostalCode')] = asText(address.postalCode),
        _a[fieldName('Email')] = asText(address.email),
        _a[fieldName('Phone')] = formatPhoneInput(asText(address.phone)),
        _a;
};
export var toContactOptions = function (contactInfo, entityTypeCode) {
    if (!Array.isArray(contactInfo)) {
        return [];
    }
    var titleOptions = getTitleOptions(entityTypeCode);
    return contactInfo
        .filter(function (contact) {
        return contact &&
            !contact.GIndex &&
            !contact.GuarantorId &&
            !contact.GuarantorAspireOId;
    })
        .map(function (contact, contactIndex) {
        var _a, _b;
        var rawTitle = asText(contact.Title);
        var matchedTitle = titleOptions.find(function (option) {
            return String(option.label).toLowerCase() === rawTitle.toLowerCase() ||
                String(option.value).toLowerCase() === rawTitle.toLowerCase();
        });
        return {
            id: asText(contact.ContactAspireOId) ||
                asText(contact.Id) ||
                String(contactIndex),
            firstName: asText(contact.FirstName),
            middleName: asText(contact.MiddleName),
            lastName: asText(contact.LastName),
            suffix: asText(contact.Suffix),
            titleValue: String((_a = matchedTitle === null || matchedTitle === void 0 ? void 0 : matchedTitle.value) !== null && _a !== void 0 ? _a : ''),
            titleLabel: String((_b = matchedTitle === null || matchedTitle === void 0 ? void 0 : matchedTitle.label) !== null && _b !== void 0 ? _b : rawTitle),
            email: asText(contact.Email),
            phone: asText(contact.PhoneNumber),
        };
    });
};
var buildIndividualCustomerValues = function (customer, countryCode) {
    var _a;
    var _b;
    var rawTaxId = toRawTaxId(customer.SSN);
    return _a = {},
        _a[CUSTOMER_FIELD.SignerFirstName] = asText(customer.FirstName),
        _a[CUSTOMER_FIELD.SignerMiddleName] = asText(customer.MiddleName),
        _a[CUSTOMER_FIELD.SignerLastName] = asText(customer.LastName),
        _a[CUSTOMER_FIELD.SignerSuffix] = asText(customer.Suffix),
        _a[CUSTOMER_FIELD.BusinessTitle] = asText(customer.BusinessTitle),
        _a[CUSTOMER_FIELD.TaxpayerId] = rawTaxId
            ? countryCode === CANADA_COUNTRY_CODE
                ? formatSINInput(rawTaxId)
                : formatSSNInput(rawTaxId)
            : '',
        _a[CUSTOMER_FIELD.DateOfBirth] = toFormDate((_b = customer.DOB) !== null && _b !== void 0 ? _b : customer.DateOfBirth),
        _a;
};
export var buildCustomerLookupValues = function (matched, isConsumerProgram) {
    var _a, _b, _c;
    var _d;
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    var customer = (_d = matched.CustomerInfo) !== null && _d !== void 0 ? _d : {};
    var entityTypeCode = resolveEntityTypeCode(customer.CompanyDesc);
    var incorporation = resolveCountryAndState(customer.CustState);
    var locationAspireOId = asText(customer.LocationAspireOId);
    var billToLocationAspireOId = asText(customer.BillToLocationAspireOId);
    var isBillingSameAsMain = Boolean(locationAspireOId && locationAspireOId === billToLocationAspireOId);
    return __assign(__assign(__assign(__assign(__assign((_a = {}, _a[CUSTOMER_FIELD.EntityType] = entityTypeCode, _a[CUSTOMER_FIELD.LegalRegisteredName] = asText(customer.LegalRegisteredName), _a[CUSTOMER_FIELD.DbaName] = asText(customer.DBAName), _a[CUSTOMER_FIELD.Country] = incorporation.countryCode, _a[CUSTOMER_FIELD.StateOfIncorporation] = incorporation.stateCode, _a[CUSTOMER_FIELD.DateBusinessIncorporated] = toFormDate(customer.DateBusinessIncorporated), _a[CUSTOMER_FIELD.FedTaxId] = formatTaxIdForDisplay(customer.SSN), _a[CUSTOMER_FIELD.GrossAnnualRevenue] = customer.GrossRevenue
        ? formatAmountInput(String(customer.GrossRevenue))
        : '', _a[CUSTOMER_FIELD.TaxExempt] = asText(customer.TaxExempt) !== ''
        ? (Number(customer.TaxExempt) === 1 ? 1 : 0)
        : '', _a), (isConsumerProgram
        ? buildIndividualCustomerValues(customer, incorporation.countryCode)
        : {})), buildAddressValues(MAIN_ADDRESS_PREFIX, {
        street: customer.MainAddress,
        city: customer.City,
        state: customer.State,
        postalCode: customer.PostalCode,
        email: customer.Email,
        phone: customer.PhoneNumber,
    })), (_b = {}, _b[CUSTOMER_FIELD.BillingSameAsMain] = isBillingSameAsMain, _b)), buildAddressValues(BILLING_ADDRESS_PREFIX, {
        street: customer.BillingAddress,
        city: customer.BillingCity,
        state: customer.BillingState,
        postalCode: customer.BillingPostalCode,
        email: customer.BillingEmail,
        phone: customer.BillingPhoneNumber,
    })), (_c = {}, _c[CUSTOMER_ASPIRE_FIELD.CustomerAspireId] = asText(customer.CustomerAspireId), _c[CUSTOMER_ASPIRE_FIELD.CustomerAspireOId] = asText(customer.CustomerAspireOId), _c[CUSTOMER_ASPIRE_FIELD.CustomerAspireRecordId] = asText(customer.CustomerAspireRecordId), _c[CUSTOMER_ASPIRE_FIELD.LocationAspireOId] = locationAspireOId, _c[CUSTOMER_ASPIRE_FIELD.BillToLocationAspireOId] = billToLocationAspireOId, _c[CUSTOMER_ASPIRE_FIELD.IsFromExistingCustomer] = true, _c));
};
var applyMatch = function (matched, onContacts, isConsumerProgram, confirmMatch) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var values, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    values = buildCustomerLookupValues(matched, isConsumerProgram);
                    _a = confirmMatch;
                    if (!_a) return [3, 2];
                    return [4, confirmMatch(values)];
                case 1:
                    _a = !(_c.sent());
                    _c.label = 2;
                case 2:
                    if (_a) {
                        onContacts === null || onContacts === void 0 ? void 0 : onContacts([]);
                        return [2, null];
                    }
                    onContacts === null || onContacts === void 0 ? void 0 : onContacts(toContactOptions(matched.Contacts, String((_b = values[CUSTOMER_FIELD.EntityType]) !== null && _b !== void 0 ? _b : '')));
                    return [2, values];
            }
        });
    });
};
export var createCustomerTaxIdLookup = function (beginContactsReport, isConsumerProgram, confirmMatch) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return function (taxId, values) { return __awaiter(void 0, void 0, void 0, function () {
        var onContacts, matched;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onContacts = beginContactsReport === null || beginContactsReport === void 0 ? void 0 : beginContactsReport();
                    return [4, fetchCustomerByTaxId(taxId, values, isConsumerProgram)];
                case 1:
                    matched = _a.sent();
                    if (!matched) {
                        onContacts === null || onContacts === void 0 ? void 0 : onContacts([]);
                        return [2, null];
                    }
                    return [2, applyMatch(matched, onContacts, isConsumerProgram, confirmMatch)];
            }
        });
    }); };
};
export var createLegalNameSearch = function (beginContactsReport, isConsumerProgram, confirmMatch) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return ({
        search: function (term) { return searchAccountsByLegalName(term, isConsumerProgram); },
        select: function (option) { return __awaiter(void 0, void 0, void 0, function () {
            var onContacts, matched;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onContacts = beginContactsReport === null || beginContactsReport === void 0 ? void 0 : beginContactsReport();
                        return [4, fetchCustomerByAccountAspireOId(String(option.value), isConsumerProgram)];
                    case 1:
                        matched = _a.sent();
                        if (!matched) {
                            onContacts === null || onContacts === void 0 ? void 0 : onContacts([]);
                            return [2, null];
                        }
                        return [2, applyMatch(matched, onContacts, isConsumerProgram, confirmMatch)];
                }
            });
        }); },
    });
};
